<h1 mat-dialog-title>{{ dialogTextEditRequest.textMenu }}</h1>
<div mat-dialog-content class="comment-div-scroll">
    <angular-editor id="editorHistoriaClinicaObservacion" placeholder="Texto" [(ngModel)]="dialogTextEditRequest.text" [config]="editorConfig"></angular-editor>
</div>
<div class="clearfix">
    <div class="pull-right">
        <button mat-button type="button" (click)="save()">Guardar</button>
        <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
    </div>
</div>